import cn from 'classnames'
import * as React from 'react'
import { useIntl } from '@/intl'
import styles from '@/scopes/checkout/components/PersonalDetailsForm/Form.module.css'
import formInputStyles from '@/scopes/checkout/components/PersonalDetailsForm/Inputs/FormInput.module.css'
import { availablePhoneCountriesSelector } from '@/scopes/checkout/components/PersonalDetailsForm/selectors'
import { useTrackFieldValidation } from '@/scopes/checkout/components/PersonalDetailsForm/useTrackFieldValidation'
import { shouldShowHelpTextForMobilePhoneInputOnPersonalDetailsStep } from '@/scopes/checkout/domain/policies/siteName'
import { useParticipantsFormStepStore } from '@/scopes/checkout/infrastructure/store/useParticipantsFormStepStore'
import { PhoneInput } from '@/scopes/common/components/FormElements/PhoneInput'
import { getPhoneDigitsFromPattern, getPhoneExampleFromDigits } from '@/scopes/common/components/FormElements/utils/phonePatternUtils'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'

export function MobilePhoneNumberInput({
  name,
  required = false,
}: {
  name: string
  pattern?: string
  required?: boolean
}) {
  const intl = useIntl()
  const availablePhoneCountries = useParticipantsFormStepStore(availablePhoneCountriesSelector)
  useTrackFieldValidation(name)
  const siteName = useConfiguration('siteName')
  const helpText = shouldShowHelpTextForMobilePhoneInputOnPersonalDetailsStep(siteName)
    ? intl.formatMessage({
        id: 'checkout_steps_participants_form_field_help_text_mobile_phone',
      })
    : undefined
  return (
    <PhoneInput
      name={name}
      label={intl.formatMessage({ id: 'checkout_steps_participants_form_field_label_mobile_phone' })}
      required={required}
      requiredErrorMessage={intl.formatMessage({
        id: 'checkout_steps_participants_form_field_required_error_message_mobile_phone',
      })}
      patternErrorMessage={(selectedCountry) => {
        const phoneDigits = getPhoneDigitsFromPattern(selectedCountry?.pattern)

        return intl.formatMessage(
          { id: 'checkout_steps_participants_form_field_pattern_error_message_mobile_phone' },
          { phoneDigits, phoneExample: getPhoneExampleFromDigits(phoneDigits) },
        )
      }}
      countries={availablePhoneCountries}
      formFieldClass={cn(styles.personalDetailsFormField, formInputStyles.formFieldM)}
      helpText={helpText}
    />
  )
}
